var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailSettingsIcon = function SvgMailSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h14v9H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2 4 7 5.5L16 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15v.8M18.5 21.2v.8M15.5 18.5h.8M20.7 18.5h.8M16.03 16.03l.57.57M20.4 20.4l.57.57M16.03 20.97l.57-.57M20.4 16.6l.57-.57"
  })));
};
export default SvgMailSettingsIcon;